module.exports = __webpack_public_path__ + "img/blockquote.c2184610.svg";